import React, { Component } from "react";
import {
    SlPageTitle,
    SlButton,
    SlSectionTitle,
    SlBusyIndicator
} from "./editors";
import { LoanInfoApi } from "../_services";
import { metadataService, userService, ServiceUtil as serviceUtil } from "../_services";
import { Alert } from "reactstrap";
import { history } from "../_helpers";
import { SelectLoan, SetPayment, RePay } from "./subcomponents";
import { newLoanActions } from "../_actions";
import { connect } from 'react-redux';
import { MakePaymentVerifyIdentity } from "./subcomponents/MakePaymentVerifyIdentity";
import { PaymentSuccess } from "./subcomponents/PaymentSuccess";

class MakePayment extends Component {
    //static displayName = MyProfile.name;

    constructor(props) {
        super(props);
        this.STEP_INITIALIZING = 0;
        this.STEP_VERIFYIDENTITY = 1
        this.STEP_SELECT_LOAN = 2;
        this.STEP_SET_PAYINFO = 3;
        this.STEP_REPAY = 4;
        this.STEP_COMPLETED = 5;
        this.STEP_SIGN_UP = 6;


        this.state = {
            paymentInfo: [],
            cardVault: [],
            currentStep: 0,
            selectedLoan: {},
            paymentAmount: 0,
            paymentType: "",
            showPayoffError: false,
            showSuggestedPaymentWarning: false,
            enableAchPayments: false,
            selectedPaymentCard: null,
            canMoveNext: false,
            isWorking: false,
            repayUrl: "",
            paymentSessionId: "",
            errorMessage: "",
            localBranch: {},
            payoffMessage: 'PayoffAtCustomerService',
            isBranchAvailable: false,
            branchPhone: "",
            iframeStyle: {
                minHeight: "95vh",
                width: "100%",
                border: "0px",
                display: "flex"
            },
            userHash: "",
            isUnAuthenticatedUser: false,
            hashInUse: false,
            ACHNextInstallment: 0,
            ACHNextDue: "",
            convenienceFees: ""
        };

        this.loanSelected = this.loanSelected.bind(this);
        this.handleOnNext = this.handleOnNext.bind(this);
        this.handleOnBack = this.handleOnBack.bind(this);
        this.handleOnCardSelected = this.handleOnCardSelected.bind(this);
        this.handleOnPaymentTypeChanged = this.handleOnPaymentTypeChanged.bind(this);
        this.handlePaymentAmountChanged = this.handlePaymentAmountChanged.bind(this);
        this.handleOnCardsDeleted = this.handleOnCardsDeleted.bind(this);
        this.handleRePayMessage = this.handleRePayMessage.bind(this);
        this.handleOnCardsDeleted = this.handleOnCardsDeleted.bind(this);
        this.setParentState = this.setParentState.bind(this);
    }

    handleBack() { }

    canMoveNext() {
        return this.state.paymentAmount > 0 &&
            this.state.paymentAmount <= this.state.selectedLoan.loanAccountView.payoff &&
            (this.state.paymentType === "card" || this.state.paymentType === "ach") &&
            this.state.currentStep !== this.STEP_REPAY;
    }

    setMoveNext(stateChanges) {
        const newState = { ...this.state, ...stateChanges };
        let canMoveNext = false;

        if (this.state.currentStep === this.STEP_SELECT_LOAN) {
            //need to have a current loan
            canMoveNext = newState.selectedLoan != null;
        }

        if (this.state.currentStep === this.STEP_SET_PAYINFO) {
            canMoveNext =
                newState.paymentAmount > 0 &&
                newState.paymentAmount <= newState.selectedLoan.loanAccountView.payoff &&
                (newState.paymentType === "card" || newState.paymentType === "ach");

            if (newState.paymentAmount > newState.selectedLoan.loanAccountView.payoff) {
                this.setState({ showPayoffError: true, showSuggestedPaymentWarning: false })
            }
            else if (newState.paymentAmount < newState.selectedLoan.loanAccountView.suggestedPayment && newState.paymentAmount !== 0) {
                this.setState({ showPayoffError: false, showSuggestedPaymentWarning: true })
            }
            else {
                this.setState({ showPayoffError: false, showSuggestedPaymentWarning: false })
            }
        }

        return { ...stateChanges, ...{ canMoveNext: canMoveNext, errorMessage: null } };
    }

    async checkAutoAch(loanId) {
        var achAuthorizationResponse = await LoanInfoApi.getACHAuthorization(loanId);

        if (achAuthorizationResponse.httpResponseCode === 200 && achAuthorizationResponse.data != null) {
            var achAuthorization = achAuthorizationResponse.data;
            this.setState({ ACHNextDue: achAuthorization.nextDue, ACHNextInstallment: achAuthorization.nextInstallment });
        }
    }

    loanSelected(currentLoanId) {
        const selected = this.state.paymentInfo.find(function (e) {
            return e.loanAccountView.currentLoanId == currentLoanId;
        });

        this.checkAutoAch(currentLoanId);

        this.setState(
            this.setMoveNext({
                selectedLoan: selected,
                paymentAmount: selected.loanAccountView.upToDate,
            })
        );
    }

    handleOnNext() {
        const newState = this.state.currentStep + 1;

        switch (newState) {
            case this.STEP_SET_PAYINFO:
            case this.STEP_SELECT_LOAN:
                this.setState(this.setMoveNext({
                    currentStep: newState,
                    paymentSessionId: "",
                    repayUrl: "",
                }));
                break;
            case this.STEP_REPAY:
                this.setState({
                    currentStep: newState,
                    isWorking: true,
                    canMoveNext: false
                });
                LoanInfoApi.getPaymentUrl(
                    this.state.selectedLoan.loanAccountView.currentLoanId,
                    this.state.paymentAmount,
                    this.state.selectedPaymentCard === null ? this.state.paymentType : this.state.selectedPaymentCard.storedPaymentType,
                    this.state.selectedPaymentCard === null ? null : this.state.selectedPaymentCard.storedPmtId,
                    this.state.userHash
                ).then(response => {
                    if (response.status <= 1) {
                        this.setState({
                            repayUrl: response.data.paymentUrl,
                            isWorking: false,
                            paymentSessionId: response.data.paymentSessionId
                        });
                    }
                    else {
                        //failure response. 
                        this.setState({
                            errorMessage: response.message,
                            isWorking: false,
                            currentStep: this.STEP_SELECT_LOAN
                        })
                    }
                });
                break;
            case this.STEP_SIGN_UP:
                this.setState({
                    currentStep: newState,
                    isWorking: true,
                    canMoveNext: false
                });

                if (this.state.isUnAuthenticatedUser) {
                    userService.isHashInUse(this.state.userHash).then(hashResponse => {
                        this.setState({
                            hashInUse: hashResponse.data,
                            isWorking: false,
                            canMoveNext: true
                        });
                    });
                } else {
                    serviceUtil.setReloadAccountHistory(true);
                    history.push("/my-account");
                }
                break;
            default:
                this.setState(
                    this.setMoveNext({
                        currentStep: newState,
                    })
                );
                break;
        }
    }

    handleOnCardsDeleted(cardsToDelete) {
        if (cardsToDelete.length > 0) {
            LoanInfoApi.deleteSavedPayments(cardsToDelete).then(e => {
                if (e.status < 2) {
                    this.setState({ cardVault: e.data })
                }
            })
        }
    }

    handleRePayMessage(data) {
        if (data === "PAYMENT_SUCCESS") {
            LoanInfoApi.setPaymentSession(this.state.paymentSessionId, true).then(
                e => {
                    this.setState({
                        currentStep: this.STEP_COMPLETED,
                        canMoveNext: true
                    });
                }
            );
        } else if (data === "PAYMENT_ERROR") {
            LoanInfoApi.setPaymentSession(this.state.paymentSessionId, false);
        }
    }

    handleOnBack() {
        if (this.state.currentStep <= this.STEP_SELECT_LOAN) {
            history.push("/my-account");
        }
        else {
            this.setState({
                currentStep: this.state.currentStep - 1,
                canMoveNext: true,
                errorMessage: null
            });
        }
    }

    handleOnPaymentTypeChanged(newType) {
        this.setState(this.setMoveNext({ paymentType: newType }));
    }

    handlePaymentAmountChanged(newAmount) {
        this.setState(this.setMoveNext({ paymentAmount: newAmount }));
        //this.setState(this.setMoveNext({ upToDate: newAmount }));
    }

    handleOnCardSelected(newCard) {
        this.setState(this.setMoveNext({ selectedPaymentCard: newCard }));
    }

    handleCardDeleted(deletedCardIds) {
        const newVault = this.state.cardVault.filter(function (val, idx, arr) {
            return deletedCardIds.find(e => e === val.storedPmtId);
        });

        this.setState({ cardVault: newVault });
    }

    componentDidMount() {
        //Start the payment process.
        //Need to initiate process.
        const user = userService.getCurrentUser();
        if (!user) this.setState({ currentStep: this.STEP_VERIFYIDENTITY, isUnAuthenticatedUser: true })

        if (this.props.match.params.id) {
            LoanInfoApi.startPayment().then(response => {
                const selectedLoanId = this.props.match.params.id;
                //find the loan (if it's there) and select it.
                const selectedLoan = response.data.paymentInfo.find(function (e) {
                    return e.loanAccountView.currentLoanId === Number(selectedLoanId);
                });

                var sunLoanBranchId = serviceUtil.getLocalBranchId();
                var localBranch = null;
                var payoffMessage = 'PayoffAtCustomerService';
                var isBranchAvailable = false;
                var branchPhone = '';

                if (sunLoanBranchId) {
                    metadataService.getBranch(sunLoanBranchId).then(response => {
                        localBranch = response.data;
                        payoffMessage = (localBranch) ? 'PayoffAtBranch' : "PayoffAtCustomerService";
                        isBranchAvailable = (localBranch) ? true : false;
                        branchPhone = (localBranch) ? localBranch.phone : "";

                        this.setState({
                            localBranch: localBranch,
                            branchPhone: branchPhone,
                            isBranchAvailable: isBranchAvailable,
                            payoffMessage: payoffMessage
                        });
                    });
                }

                var firstStep = this.STEP_SELECT_LOAN;
                if (selectedLoan != null) {
                    firstStep = this.STEP_SET_PAYINFO;
                    this.checkAutoAch(selectedLoan.loanAccountView.currentLoanId);
                }

                this.setState({
                    paymentInfo: response.data.paymentInfo,
                    cardVault: response.data.cardVault,
                    currentStep: firstStep,
                    selectedLoan: selectedLoan,
                    canMoveNext: true,
                    paymentAmount: selectedLoan.loanAccountView.upToDate,
                    isWorking: false,
                    enableAchPayments: response.data.enableACHPayments,
                    convenienceFees: response.data.convenienceFees
                });
            });
        }
    }

    setParentState(response, firstStep, selectedLoan, userHash) {
        if (selectedLoan !== undefined) {
            this.setState({
                paymentInfo: response.data.paymentInfo,
                cardVault: response.data.cardVault,
                currentStep: firstStep,
                selectedLoan: selectedLoan,
                canMoveNext: true,
                paymentAmount: selectedLoan.loanAccountView.upToDate,
                isWorking: false,
                userHash: userHash,
                enableAchPayments: response.data.enableACHPayments,
                convenienceFees: response.data.convenienceFees
            })
        } else {
            this.props.actions.unableToFindAccount();
        }
    }

    render() {
        if (this.state.isWorking) {
            return <SlBusyIndicator visible="true" />
        }

        switch (this.state.currentStep) {
            case this.STEP_VERIFYIDENTITY:
                return (
                    <div>
                        <MakePaymentVerifyIdentity setParentState={this.setParentState} STEP_SELECTLOAN={this.STEP_SELECTLOAN}
                            STEP_SET_PAYINFO={this.STEP_SET_PAYINFO} />
                    </div>
                );
            case this.STEP_SIGN_UP:
                return (
                    <div>
                        <PaymentSuccess hasAccount={this.state.hashInUse} userHash={this.state.userHash} />
                    </div>
                );
            default:
                return (
                    <div>
                        <div id="backBtnContainer" hidden>
                            <SlButton name="Back" onClick={this.handleBack} />
                        </div>
                        <SlPageTitle pageName="MakePayment" />
                        {this.state.errorMessage && (
                            <Alert color='danger'>{this.state.errorMessage}</Alert>
                        )}
                        {/* 
                            List current available accounts and allow selection
                            Account in URL, if any, is pre-selected. 
                        */}
                        {(this.state.isWorking && <SlBusyIndicator visible="true" />) ||
                            (this.state.currentStep === this.STEP_SELECT_LOAN && (
                                <React.Fragment>
                                    <SlSectionTitle sectionName="SelectLoan" />
                                    {this.state.paymentInfo.map(e => {
                                        return (
                                            <SelectLoan
                                                key={e.loanAccountView.currentLoanId}
                                                loan={e}
                                                onLoanSelected={this.loanSelected}
                                                isSelected={
                                                    e.loanAccountView.currentLoanId === this.state.selectedLoan.loanAccountView.currentLoanId
                                                }
                                            />
                                        );
                                    })}
                                </React.Fragment>
                            )) ||
                            /*
                            Show the payment selection.  
                            */
                            (this.state.currentStep === this.STEP_SET_PAYINFO && (
                                <React.Fragment>
                                    <SlSectionTitle sectionName="SelectPayment" />
                                    <h4 className="padLeft3Rem">{metadataService.getMessage('LoanNumber', metadataService.maskExceptLastFourCharacters(this.state.selectedLoan.loanAccountView.currentLoanId.toString()))}</h4>
                                    <p class="text-center">{metadataService.getMessage('ACHpayment')}</p>
                                    <SetPayment
                                        loanToPay={this.state.selectedLoan.loanAccountView}
                                        savedCards={this.state.cardVault}
                                        paymentAmount={this.state.paymentAmount}
                                        showPayoffError={this.state.showPayoffError}
                                        showSuggestedPaymentWarning={this.state.showSuggestedPaymentWarning}
                                        selectedPaymentType={this.state.paymentType}
                                        selectedCard={this.state.selectedPaymentCard}
                                        isBranchAvailable={this.state.isBranchAvailable}
                                        payoffMessage={this.state.payoffMessage}
                                        localBranch={this.state.localBranch}
                                        branchPhone={this.state.branchPhone}
                                        onPaymentTypeChanged={this.handleOnPaymentTypeChanged}
                                        onPaymentAmountChanged={this.handlePaymentAmountChanged}
                                        onCardSelected={this.handleOnCardSelected}
                                        onCardsDeleted={this.handleOnCardsDeleted}
                                        enableAchPayments={this.state.enableAchPayments}                                       
                                        convenienceFees={this.state.convenienceFees}
                                    />
                                </React.Fragment>
                            )) ||
                            ((this.state.currentStep === this.STEP_REPAY || this.state.currentStep === this.STEP_COMPLETED) && (
                                <div>{this.state.ACHNextInstallment > 0 &&
                                    <h4 className="text-center">{metadataService.getMessage("ACHNextInstallment", metadataService.formatDateString(this.state.ACHNextDue), metadataService.formatMoney(this.state.ACHNextInstallment))}</h4>
                                }
                                    <RePay
                                        iframeStyle={this.state.iframeStyle}
                                        repayUrl={this.state.repayUrl}
                                        onMessage={this.handleRePayMessage}
                                    />
                                </div>
                            ))
                        }

                        <div>
                            <div className="text-center">
                                {this.state.currentStep > 1 && (
                                    <SlButton name="Back" onClick={this.handleOnBack} />
                                )}
                                {this.state.currentStep > 0 && (
                                    <SlButton
                                        name="Next"
                                        onClick={this.handleOnNext}
                                        disabled={!this.canMoveNext()}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                );
        }
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            unableToFindAccount: () => {
                dispatch(newLoanActions.accountNotFound(metadataService.getMessage("ErrorCannotFindLoan")));
            }
        }
    };
}

const connectedMakePayment = connect(
    null,
    mapDispatchToProps
)(MakePayment)

export { connectedMakePayment as MakePayment };


// WEBPACK FOOTER //
// ./src/components/MakePayment.jsx